export default function () {
    const wrapper = document.querySelector(".js-wrapper");
    const burgerMenu = document.querySelector(".js-mobile-burger");

    burgerMenu.addEventListener("click", () => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        burgerMenu.classList.toggle("_open");
        wrapper.classList.toggle("_open-mobile-menu");
    });
}


// WEBPACK FOOTER //
// ./uPortal/Core/Shared/Navigation/Js/mobileMenu.js